/**
 * ListItem Component.js
 * The individual Item for the List Container.
 *
 * @class   ListItem
 * @author  Yevgeniy Rokhlin
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import FontIcon from 'components/font-icon/FontIcon';
import IconButton from 'components/buttons/icon-button/IconButton';


export default React.createClass({



	displayName: "ListItem",

	propTypes: {
		direction: React.PropTypes.oneOf(['row','column']),
		maxWidth: React.PropTypes.string,
		fontIcon: React.PropTypes.string,
		fontIconMagnify: React.PropTypes.number,
		fontIconClass: React.PropTypes.string,
		image: React.PropTypes.string,
		slideButton: React.PropTypes.string,
		slideDirection: React.PropTypes.oneOf(['left','right']),
		slideAmount: React.PropTypes.oneOfType([
			React.PropTypes.string,
			React.PropTypes.number]),
		slideContent: React.PropTypes.any,
		slideContentClassName: React.PropTypes.string,
		expandButton: React.PropTypes.string,
		expandedButton: React.PropTypes.string,
		expandButtonSide: React.PropTypes.oneOf(['left','right']),
		expandDirection: React.PropTypes.oneOf(['up','down']),
		expandContent: React.PropTypes.any,
		expandContentClassName: React.PropTypes.string,
		disabled: React.PropTypes.bool,
		isActive: React.PropTypes.bool,
		meta: React.PropTypes.oneOfType([
			React.PropTypes.array,
			React.PropTypes.object]),
	},

	getDefaultProps() {
		return {
			direction: 'row',
			fontIconMagnify: 3,
			maxWidth: '',
			fontIconClass: '',
			slideDirection: 'right',
			expandButtonSide: 'left',
			expandDirection: 'down',
			disabled: false,
			meta: [],

		};
	},

	getInitialState() {
		return {
			slideOpen: false,
			expandOpen: false,
		}
	},

	componentDidMount() {

	},

	render() {
		let {
			direction,
			slideDirection,
			slideButton,
			expandButton,
			expandButtonSide,
			expandDirection,
			maxWidth,
			className,
			children,
			disabled,
			isActive } = this.props;

		let topExpandContent, bottomExpandContent;

		if (expandDirection === "up") {
			topExpandContent = this._renderExpandContent();
		
		} else if (expandDirection === "down") {
			bottomExpandContent = this._renderExpandContent();
		}


		// Assign classes as well as direction based on "direction" prop
		let listItemClasses = ClassNames('lui-list-item', className, {
			'lui-list-item-direction-column': direction === "column",
			'lui-list-item-direction-row': direction === "row",
			'lui-has-slide-left' : slideButton && slideDirection === "left",
			'lui-has-slide-right' : slideButton && slideDirection === "right",
			'lui-has-expand-left' : expandButton && expandButtonSide === "left",
			'lui-has-expand-right' : expandButton && expandButtonSide === "right",
			'lui-is-disabled' : disabled,
			'lui-is-active' : isActive
		});

		let listItemStyles = {
			maxWidth: maxWidth,
			cursor: this.props.onClick ? "pointer" : "initial"
		};

		if (this.props.style) {
		    listItemStyles = Object.assign(listItemStyles, this.props.style);
		};
		
		return (
			<div>
				{topExpandContent}
				<li 
					ref="listItem"
					style={listItemStyles}
					className={listItemClasses}
					onClick={this.props.onClick} >

					{this._renderExpandButton()}
					{this._renderSlideContent()}
					{this._renderIconContent()}
					<div className="lui-list-item-content">
						{children}
					</div>
				</li>
				{bottomExpandContent}
			</div>
		);
	},

	_renderIconContent() {

		let listItemIcon,
			listItemImage,
			listItemIconContent = [];

		let {
			fontIcon,
			fontIconClass,
			fontIconMagnify,
			image } = this.props;


		// If fontIcon prop is passed, render it.
		if (fontIcon){
			listItemIcon = (
				<FontIcon
					key={1}
					className={`lui-list-item-image ${fontIconClass}`}
					icon={fontIcon}
					magnify={fontIconMagnify} />
			);

			listItemIconContent.push(listItemIcon);
		};

		// If image prop is passed, render it.
		if (image){
			listItemImage = (
				<img key={2} className="lui-list-item-image" src={image} />
			);

			listItemIconContent.push(listItemImage);
		};

		return listItemIconContent;
	},

	_renderExpandButton() {
		if (this.props.expandButton) {

			let {
				expandButton,
				expandedButton } = this.props;

			let listItemExpandButton = (
				<IconButton 
					className="lui-list-item-expand-button" 
					icon={!this.state.expandOpen ? expandButton : expandedButton ? expandedButton : expandButton }
					onClick={this.toggleExpandContent} />
			);

			return listItemExpandButton

		};
	},

	_renderExpandContent() {
		
		if (this.props.expandContent) {

			let {
				expandAmount,
				expandDirection,
				expandContent } = this.props;



			let classes = ClassNames ("lui-list-item-expand-content-container", this.props.expandContentClassName);

			let listItemExpandContent = (
				<div ref="expandContentContainer" className={classes}>
					<div className="lui-list-item-expand-content">
						{expandContent}
					</div>
				</div>
			);

			return listItemExpandContent;
		};
	},

	toggleExpandContent() {
		this.state.expandOpen ? this.closeExpandContent() : this.openExpandContent();
	},

	openExpandContent() {
		let element = React.findDOMNode(this.refs.expandContentContainer);

		let prevheight = element.style.height;
		
		element.style.height = 'auto';
		
		let endheight = getComputedStyle(element).height;
		
		element.style.height = prevheight;
		element.offsetHeight; // force repaint
		element.style.transition = 'height .1s';
		element.style.height = endheight;
		
		let _this = this;
		element.addEventListener('transitionend', function transitionEnd(event) {
			if (event.propertyName == 'height') {
				element.style.transition = '';
				element.style.height = 'auto';
				element.removeEventListener('transitionend', transitionEnd, false);
			}
		}, false);

		this.setState({
			expandOpen: true
		});
	},

	closeExpandContent() {
		let element = React.findDOMNode(this.refs.expandContentContainer);

		element.style.height = getComputedStyle(element).height;
		element.style.transition = 'height .1s';
		element.offsetHeight; // force repaint
		element.style.height = '0px';

		let _this = this;
		element.addEventListener('transitionend', function transitionEnd(event) {
			if (event.propertyName == 'height') {
				element.removeEventListener('transitionend', transitionEnd, false);
			}
		}, false);

		this.setState({
			expandOpen: false
		});
	},

	_renderSlideContent() {

		if (this.props.slideButton) {

			let {
				slideAmount,
				slideDirection,
				slideButton,
				slideContent } = this.props;

			let listItemSlideButton = (
				<IconButton
					key={slideButton} 
					className="lui-list-item-slide-button" 
					icon={slideButton}
					onClick={this._slideListItem} />
			);

			// Offset the left/right of the slide content
			let slideContentStyle = this._determineSlideContentStyle(slideAmount, slideDirection);

			let classes = ClassNames("lui-list-item-slide-content", this.props.slideContentClassName)

			let listItemSlideContent = (
					<div 
						key={slideContent}
						ref="slideContent" 
						style={slideContentStyle} 
						className={classes}>
						{slideContent}
					</div>
			);
			
			return [listItemSlideButton, listItemSlideContent]
		};
	},

	_slideListItem() {
		let listItem = React.findDOMNode(this.refs.listItem),
			listItemWidth = listItem.offsetWidth,
			slideAmount = this.props.slideAmount,
			slideContent = React.findDOMNode(this.refs.slideContent),
			slideDirection = this.props.slideDirection;

		// if slide is closed, open it	
		if (!this.state.slideOpen) {
			
			if (slideDirection === "left") {
				// if it's a number, treat it like pixels 
				if (typeof slideAmount === "number") {
					listItem.style.left = (slideAmount * -1) + "px";			
				// if it's a string, treat it like a percentage, in this case
				// also strip the percentage sign, negate the number, and add the 
				// percentage sign back.
				
				} else if (typeof slideDirection === "string") {
					listItem.style.left = (parseInt(slideAmount,10) * -1)+'%';
				}
			
			} else if (slideDirection === "right" ) {
				
				if (typeof slideAmount === "number") {
					listItem.style.left = slideAmount + "px";			
				
				} else if (typeof slideDirection === "string") {
					listItem.style.left = slideAmount;
				}
			}
		// if slide open, close it	
		} else {
			listItem.style.left = 0;
		}

		this.setState({
			slideOpen: !this.state.slideOpen
		});
	},

	_determineSlideContentStyle(slideAmount, slideDirection) {
		let slideContentStyle;
		
		// Determine if slideAmount value is a percentage or px value
		// and apply left/right offset based on slideDirection
		if (typeof slideAmount === "number") {
			
			if (slideDirection === "right") {
				slideContentStyle = {
					left: (slideAmount * -1) + "px",
					width: slideAmount + "px"
				};
			} else if (slideDirection === "left") {
				slideContentStyle = {
					right: (slideAmount * -1) + "px",
					width: slideAmount + "px"

				};
			}

		} else if (typeof slideAmount === "string") {
			
			if (slideDirection === "right") {
				slideContentStyle = {
					left: "-" + slideAmount,
					width: slideAmount
				}
			} else if (slideDirection === "left") {
				slideContentStyle = {
					right: "-" + slideAmount,
					width: slideAmount
				}
			}
		}

		return slideContentStyle;

	},

	_expandListItem() {

	},

});


/** WEBPACK FOOTER **
 ** ./src/components/list/ListItem.js
 **/